var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestaurantMini(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    color: "#484848",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maki:bar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 1.3999C7.69998 1.3999 0.699982 1.7499 1.39998 2.4499L9.79998 11.1999V16.7999C9.79998 18.1999 5.59998 17.4999 5.59998 19.5999H15.4C15.4 17.4999 11.2 18.1999 11.2 16.7999V11.1999L19.6 2.4499C20.3 1.7499 13.3 1.3999 10.5 1.3999ZM10.5 2.7999C14 2.7999 17.15 3.1499 17.15 3.1499L16.1 4.1999H4.89998L3.84998 3.1499C3.84998 3.1499 6.99998 2.7999 10.5 2.7999Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantMini);
export default __webpack_public_path__ + "static/media/restaurant-mini.7fc3500949b9dba17ed6a7f5ac0e53ca.svg";
export { ForwardRef as ReactComponent };